/**
 * Simple API for dealing with local storage
 */

 /**
  * @param String key Key can be the string identifying the key in localStorage
  * or can be a string using object notation 'object.property' to drill down and
  * get a specific value nested in a json object
  * @param String defaultValue a default value to be returned if value is undefined
  * @return mixed
  */
let get = function(key, defaultValue){
    // --- Allow for getting values based on object notation
    let keyParts = key.split('.');

    // --- The 'majorKey' is the actual key for the item in local storage
    // --- get it to get the local storage item
    let majorKey = keyParts.shift();
    let value = localStorage.getItem(majorKey);

    // --- If the major key in local storage doesn't exist, then return
    // --- the default value
    if(!value){
        return defaultValue;
    }

    // --- If it is a string, check to see if it's a json object
    try {
        value = JSON.parse(value);
    } catch (error) {
        // --- If it's not json, maybe it's a normal string or otherwise; return it
        return value ?
            value : 
            defaultValue;
    }

    // --- If we have a json object then drill down to get deep nested
    // --- properties using a while loop
    let i = 0;
    while(i < keyParts.length){
        if(value){
            value = value[keyParts[i]];     
        }
        i++; 
    }

    if(
        typeof value == 'undefined' &&
        defaultValue
    ){
        value = defaultValue;
    }

    return value;
}

 /**
  * @param String key Key can be the string identifying the key in localStorage
  * or can be a string using object notation 'object.property' to drill down and
  * get a specific value nested in a json object
  * @param mixed value The value to store in localStorage
  * @return mixed
  */
let set = function(key, value){
        // --- Allow for getting values based on object notation
    let keyParts = key.split('.');

    // --- The 'majorKey' is the actual key for the item in local storage
    // --- get it to get the local storage item. Use our get() function to
    // --- make sure we get the object and not a json string
    let majorKey = keyParts.shift();
    let localStorageItem = get(majorKey);

    if(keyParts.length === 0){
        // --- If this isn't a nested property, set the value outright
        localStorageItem = value;
    } else {
        if(
            // --- If the item doesn't exist yet it'll return undefined since
            // --- our call to get() does not include a defaultValue
            typeof localStorageItem === 'undefined' ||
            localStorageItem === null
        ){
            localStorageItem = {};
        }
        dottieSet(localStorageItem, keyParts.join('.'), value);
    }

    if(typeof localStorageItem === 'object'){
        localStorageItem = JSON.stringify(localStorageItem);
    }
    

    localStorage.setItem(majorKey, localStorageItem);
}

// --- This is taken from Dottie.js to set tha values internally
// --- It requires passing the object into the function but we don't
// --- want to use this in our local storage set so we separate this
// --- out to be used by our function
// --- https://github.com/mickhansen/dottie.js/blob/master/dottie.js#L73

// Weird IE shit, objects do not have hasOwn, but the prototype does...
var hasOwnProp = Object.prototype.hasOwnProperty;
let dottieSet = function(object, path, value, options) {
    var pieces = Array.isArray(path) ? path : path.split('.'), current = object, piece, length = pieces.length;

    if (typeof current !== 'object') {
        throw new Error('Parent is not an object.');
    }

    for (var index = 0; index < length; index++) {
        piece = pieces[index];

        // Create namespace (object) where none exists.
        // If `force === true`, bruteforce the path without throwing errors.
        if (!hasOwnProp.call(current, piece) || current[piece] === undefined || (typeof current[piece] !== 'object' && options && options.force === true)) {
            current[piece] = {};
        }

        if (index == (length - 1)) {
            // Set final value
            current[piece] = value;
        } else {
            // We do not overwrite existing path pieces by default
            if (typeof current[piece] !== 'object') {
                throw new Error('Target key "' + piece + '" is not suitable for a nested value. (It is in use as non-object. Set `force` to `true` to override.)');
            }

            // Traverse next in path
            current = current[piece];
        }
    }

    // Is there any case when this is relevant? It's also the last line in the above for-loop
    current[piece] = value;
};

export default {
    get: get,
    set: set
}